import { render } from "./Page.vue?vue&type=template&id=f4ca354a&bindings={\"app\":\"props\",\"id\":\"data\",\"isCopying\":\"data\",\"page\":\"options\",\"isArchived\":\"options\",\"ancestors\":\"options\",\"body\":\"options\",\"getAncestors\":\"options\",\"getAncestor\":\"options\",\"copy\":\"options\"}"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script